import Joi from 'joi';
import PropTypes from 'prop-types';

import { matchPhrases } from '../../../utils/utilities';
import { getAffirmativeOptions, getInspectionTypeOptions } from '../../../utils/data';

import Button from '../../themed/button';
import Conditional from '../../common/conditional';
import Form from '../../common/form';

import toastService from '../../../services/toastService';

class EditEquipmentItemForm extends Form {
	state = {
		data: {
			equipmentNumber: '',
			equipmentDescription: '',
			hasPID: '',
			hasPDO: '',
			hasAnomalies: '',
			inspectionType: '',
			inspectionDescription: 'No anomalies observed.',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		equipmentNumber: Joi.string().min(3).required().label('Equipment Tag'),
		equipmentDescription: Joi.string().min(3).required().label('Equipment Description'),
		hasPID: Joi.string().min(2).required().label('P&ID Number'),
		hasAnomalies: Joi.string().min(2).required().label('Has Anomalies'),
		hasPDO: Joi.string().min(2).required().label('Has PDO'),
		inspectionType: Joi.string().required().label('Inspection Type'),
		inspectionDescription: Joi.string().when('hasAnomalies', {
			is: 'yes',
			then: Joi.string().allow('').optional().label('Inspection Description'),
			otherwise: Joi.string().min(3).required().label('Inspection Description'),
		}),
	};

	static propTypes = {
		equipmentDetails: PropTypes.object.isRequired,
		onEdit: PropTypes.func,
		onCancelEdit: PropTypes.func,
		showLastLineOption: PropTypes.bool,
	};


	componentDidMount() {
		if (this.props.equipmentDetails) {
			this.setState({ data: this.props.equipmentDetails });
		}
	}

	doSubmit = (): void => {
		this.props.onEdit({
			equipmentNumber: this.state.data.equipmentNumber,
			equipmentDescription: this.state.data.equipmentDescription,
			hasPID: this.state.data.hasPID,
			hasPDO: this.state.data.hasPDO,
			inspectionType: this.state.data.inspectionType,
			hasAnomalies: this.state.data.hasAnomalies,
			inspectionDescription: this.state.data.inspectionDescription,
		});

		toastService.success('Equipment Item Edited Successfully!');
	};

	getPIDOptions = () => {
		if (this.props.showLastLineOption) {
			return [...getAffirmativeOptions(), { id: 'same as last line', name: 'Same as last Line' }];
		}

		return getAffirmativeOptions();
	}

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipmentNumber',
							placeholder: 'Enter Equipment Tag',
							label: 'Equipment Tag',
						})}
					</div>
					
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipmentDescription',
							placeholder: 'Enter Equipment Description',
							label: 'Equipment Description',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'hasPID',
							placeholder: 'Does this equipment have a P&ID?',
							label: 'P&ID:',
							options: this.getPIDOptions(),
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<div className="row">
					<div className="col">
						{this.renderSelect({
							name: 'inspectionType',
							placeholder: 'Select inspection Type?',
							label: 'Inspection Type:',
							options: getInspectionTypeOptions()
						})}
					</div>
					
					<div className="col">
						{this.renderSelect({
							name: 'hasAnomalies',
							placeholder: 'Does this equipment have any anomalies?',
							label: 'Has Anomalies:',
							options: getAffirmativeOptions(),
						})}
					</div>
					
					<div className="col">
						{this.renderSelect({
							name: 'hasPDO',
							placeholder: 'Does this equipment have any PDO?',
							label: 'Has PDO:',
							options: getAffirmativeOptions(),
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<Conditional isVisible={matchPhrases(this.state.data.hasAnomalies, 'no')}>
					{this.renderTextArea({
						name: 'inspectionDescription',
						placeholder: 'Enter Inspection Description',
						label: 'Inspection Description',
						rows: '6',
					})}

					<div className="my-4 divider"></div>
				</Conditional>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Changes')}

					<div className="mx-4">
						<Button
							label="Cancel"
							style={{ backgroundColor: 'red' }}
							onClick={this.props.onCancelEdit}
						/>
					</div>
				</div>
			</form>
		);
	}
}

export default EditEquipmentItemForm;
